export default {"src":"/_next/static/media/visa_inc_logo.svg.8f2324c5.svg","height":20,"width":62,"blurWidth":0,"blurHeight":0};